// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ActionsPopoverCallback = t.struct({
    label: t.String,
    onOptionClick: t.Function,
    onOptionClickValues: t.maybe(t.Object)
}, 'ActionsPopoverCallback');

export default ActionsPopoverCallback;



// WEBPACK FOOTER //
// ./src/shared/state/actions-popover-callback.js